import * as React from 'react';

import { TechFeaturesLocale } from './techFeatures.locale';
import List from '../../List/List';
import ListItem from '../../List/ListItem';

interface TechFeaturesProps {
  locale: TechFeaturesLocale;
}

const TechFeatures: React.SFC<TechFeaturesProps> = ({ locale }) => (
  <>
    <div className="d-flex justify-content-center mb-6">
      <div className="col-12 col-md-7 text-center">
        <h2 className="mb-0">{locale.title}</h2>
      </div>
    </div>
    <List className="row">
      {locale.list.map((item, index) => (
        <ListItem key={index} className="col-12 col-md-6">
          <span dangerouslySetInnerHTML={{ __html: item }} />
        </ListItem>
      ))}
    </List>
  </>
);

export default TechFeatures;



// WEBPACK FOOTER //
// /www/client/src/components/TechnicalPage/TechFeatures/TechFeatures.tsx